/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import withLayout from './withLayout';
import SanitizedHtml from './SanitizedHtml';
const OfferDisclaimer = () => {
  return (
    <div className='grey-section-full'>
      <div className='wrapper small'>
        <div className='div-block'>
          <h1 className='_1st-header shrink'>Offer Disclaimer</h1>
          <div className='line' />
        </div>
        <div className='highlight'>
          {/* {props}*/}
          {<SanitizedHtml html={localStorage.getItem('disclaimerText')} />}
        </div>
        <div>
          <div className='terms-contact'>
            General Counsel
            <br />
            Entoro Capital, LLC
            <br />
            333 West Loop North, Suite 333
            <br />
            Houston, TX 77024
          </div>
        </div>
      </div>
    </div>
  );
};

export default withLayout(OfferDisclaimer);



// WEBPACK FOOTER //
// ./src/components/OfferDisclaimer.js